export const RF = {
  CUMULATIVE: 'RI_RESULTS_CUMULATIVE',
  ESTIMATE: 'RI_RESULTS_ESTIMATE',
}
